module.exports = __webpack_public_path__ + "bea.jpg?5802f3f00029f8ff08f133e5a41f3213";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/bea.jpg
// module id = 65
// module chunks = 0